import { createContext, useContext } from 'react';

import type { SqwLayoutProps } from './SqwLayout.types';

export type BreadcrumbOverride = {
  title: string;
  onClick: () => void;
};

export type SqwLayoutContext = {
  isSidebarExpanded: boolean;
  setIsSidebarExpanded: (value: boolean) => void;
  isMobileSidebarExpanded: boolean;
  setIsMobileSidebarExpanded: (value: boolean) => void;
  setBreadcrumbOverride: (override: BreadcrumbOverride | null) => void;
  canScrollUp: boolean;
  canScrollDown: boolean;
  scrollDirection: 'up' | 'down' | null;
  desktopSidebarTogglerMode: NonNullable<SqwLayoutProps['desktopSidebarTogglerMode']>;
  isSidebarCollapsed: boolean;
};

export const SqwLayoutContext = createContext<SqwLayoutContext | null>(null);

export const useSqwLayoutContext = () => useContext(SqwLayoutContext);

export const useSqwLayout = () => {
  const context = useContext(SqwLayoutContext);
  if (!context) throw new Error('useSqwLayout must be used within SqwLayout');

  return context;
};
